import { useTranslation } from 'react-i18next';

const HomeFrame = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div
      className={
        'flex flex-col h-full lg:flex-row w-full 3xl:w-10/12 5xl:w-8/12 justify-start lg:justify-center items-center m-auto'
      }
    >
      <div
        className={
          'w-full lg:w-1/2 p-8 pt-0 md:pt-8 md:pb-0 lg:pt-8 lg:pb-8 z-5'
        }
      >
        <div className={'flex flex-col md:flex-row lg:flex-col'}>
          <img
            alt="frame"
            src="/frame.svg"
            className={'w-full md:w-1/2 lg:w-full mr-0 md:pr-8 lg:pr-0'}
          />
          <div className={'mx-auto hidden sm:block w-full md:w-1/2 lg:w-3/4'}>
            <h2 className={'text-primary text-xl mt-4 font-semibold'}>
              {t('signIn.title')}
            </h2>
            <p className={'text-sm mt-4 text-primary'}>
              {t('signIn.subtitle')}
            </p>
          </div>
        </div>
      </div>
      <div
        className={
          'w-full lg:w-1/2 p-0 md:p-8 -mt-16 sm:mt-0 pb-4 lg:h-4/5 2xl:h-4/5 h-auto'
        }
      >
        <div
          className={
            'bg-white py-12 rounded-xl dark:bg-grey-90 h-full flex justify-between'
          }
        >
          <div
            className={
              'w-full sm:w-3/4 xl:w-1/2 px-8 mx-auto flex flex-col justify-center justify-center items-center dark:bg-grey-90 dark:text-white'
            }
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeFrame;
